// extracted by mini-css-extract-plugin
export var footer = "_my-5";
export var fulfillmentInput = "_my-0";
export var shipDateInput = "_my-1";
export var shipmentModal = "_my-2";
export var shipmentModalContent = "_my-3";
export var tableContainer = "_my-4";